module.exports = __webpack_public_path__ + "img/mingzhuta.1f3f664.png";